import React from 'react';
import './Frame.scss';

const Frame = ({ className = '', ...props }) => <div className={`frame ${className}`} {...props} />;

export default Frame;
